module.exports = __webpack_public_path__ + "img/logo_dark.c6ee1a1c.png";